import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { motion } from "framer-motion";
import { Typography } from "components";
import { useKeyPressListener } from "hooks";
import styles from "./Dialog.module.css";

const Dialog = ({ title, onClose, children }) => {
  const ref = useRef();

  useOnClickOutside(ref, onClose);
  useKeyPressListener("Escape", onClose);

  return (
    <motion.div
      className={styles.backdrop}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
    >
      <motion.div
        ref={ref}
        className={styles.container}
        initial={{ y: "-8px" }}
        animate={{ y: 0 }}
        exit={{ y: "-8px" }}
        transition={{ type: "spring", duration: 0.5, bounce: 0.5 }}
      >
        <header className={styles.header}>
          <Typography weight={500}>{title}</Typography>
        </header>
        <div className={styles.body}>{children}</div>
      </motion.div>
    </motion.div>
  );
};

export { Dialog };
